import { IVisitCategories, IVisitCategoriesListItem, VisitCategoriesResponseType } from "./visitCategories.types";

export default class VisitCategories implements  IVisitCategories {
    total: number;
    data: IVisitCategoriesListItem[] = [];
    constructor(data: VisitCategoriesResponseType) {
        this.total = data.total;
        for (let i = 0; i < data.data.length; i++) {
            this.data.push(data.data[i]);
        }
    }
}